import SearchBuilder from "@/builder/SearchBuilder";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { Pagination } from "@/models/constant/interface/common.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import {
  InternalContractCloseRequestDTO,
  InternalContractGetDTO,
  InternalContractListDto,
  InternalContractRequestDTO,
  CloseUnitsRequestDTO,
} from "@/models/interface/internal-contract";
import { DataListInternalContract } from "@/models/interface/salesOrder.interface";
import { internalContractService } from "@/services/InternalContract.service";
import { salesOrderServices } from "@/services/salesorder.service";

const useInternalContract = () => {
  const service = internalContractService;

  const createDoc = (payload: InternalContractRequestDTO) => {
    return service.create(payload);
  };

  const closeBulk = (body: InternalContractCloseRequestDTO) => {
    return service.closeBulk(body);
  };

  const closeUnits = (icId: string, body: CloseUnitsRequestDTO) => {
    return service.closeUnits(icId, body);
  };

  const findAllAvailableIc = (params: RequestQueryParams) => {
    return salesOrderServices.getListAvailableInternalContract(params);
  };

  const findById = (id: string): Promise<InternalContractGetDTO> => {
    return service.detail(id);
  };

  const findAll = (
    params?: RequestQueryParamsModel
  ): Promise<Pagination<InternalContractListDto>> => {
    return internalContractService.list(params);
  };

  const toOptions = (
    data: Array<DataListInternalContract>
  ): Array<Option<DataListInternalContract>> => {
    return data.map(item => ({
      label: item.documentNo,
      value: item.id,
      key: item.id,
      meta: item,
    }));
  };

  const findBy = ({ documentNo }: { documentNo?: string }): string => {
    if (documentNo) {
      return new SearchBuilder()
        .push(["documentNo", documentNo], { like: "both" })
        .build();
    }

    return "";
  };

  return {
    createDoc,
    closeBulk,
    closeUnits,
    findAllAvailableIc,
    findById,
    toOptions,
    findAll,
    findBy,
  };
};

export default useInternalContract;
